import { DOCUMENT, NgStyle } from '@angular/common';
import { Component, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';

import { RouterLink } from '@angular/router';
import { GlobalAnnouncementBanner } from '../../../../../types/builder-components/global-announcement-banner';
import { BuilderService } from '@scalefast/ecommerce-core';

@Component({
  imports: [NgStyle, RouterLink],
  encapsulation: ViewEncapsulation.None,
  selector: 'app-global-announcement-banner',
  standalone: true,
  styleUrls: ['./global-announcement-banner.styles.scss'],
  templateUrl: './global-announcement-banner.component.html',
})
export class AppGlobalAnnouncementBannerComponent implements OnDestroy {
  contentData: GlobalAnnouncementBanner | undefined;
  isHovering = false;
  private subscription;

  constructor(
    private builderService: BuilderService,
    @Inject(DOCUMENT) private _doc: Document,
  ) {
    this.subscription = this.builderService.getContentByModelName('global-announcement-banner').subscribe((content: any) => {
      const globalAnnouncementBannerData: GlobalAnnouncementBanner = content.data;
      if (!globalAnnouncementBannerData) {
        return;
      }
      this.contentData = globalAnnouncementBannerData;
      if (this.contentData && !this.contentData.hidden && this.contentData.text) {
        let headerSite = this._doc.getElementById('header__site');
        if (headerSite) {
          headerSite?.classList.add('global-banner');
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
